import axios from "axios";
import getEnv from "env";
import store from "app/store";
import { PublicClientApplication } from "@azure/msal-browser";
import { loginRequest, msalConfig } from "./useAuth";
import { openModalError } from "app/store/trackingApp/modalErrorSlice";

const msalInstance = new PublicClientApplication(msalConfig);

const REACT_APP_ASAP_FRACIONADOS_BASE_URL = getEnv(
  "REACT_APP_ASAP_FRACIONADOS_BASE_URL"
);

export const getAccessTokenStorage = () => sessionStorage.getItem("msToken");

const requestConfigInterceptor = (config) => {
  const accessToken = getAccessTokenStorage();

  const customConfig = {
    ...config,
  };

  if (!accessToken) {
    throw new Error("no access token");
  }

  customConfig.headers.Authorization = `Bearer ${accessToken}`;

  return customConfig;
};

const useResponseErrorInterceptor = async (error) => {
  if (error.response) {
    if (error.response.status === 401) {
      await msalInstance.logoutRedirect(loginRequest);
    } else if (error.response.status === 403) {
      try {
        const account = msalInstance.getAllAccounts()[0];
        if (!account) {
          throw new Error("No account found");
        }

        const accessTokenRequest = {
          ...loginRequest,
          account: account,
          prompt: "none",
          responseType: "id_token token",
        };

        const response = await msalInstance.acquireTokenSilent(
          accessTokenRequest
        );

        sessionStorage.setItem("msToken", response.accessToken);

        const config = error.config;
        config.headers.Authorization = `Bearer ${response.accessToken}`;

        return axios(config);
      } catch (renewError) {
        console.error("Token renewal failed", renewError);
        store.dispatch(
          openModalError({
            title: "Acesso negado",
            text: "Desculpe, você não tem permissão para acessar este recurso. Por favor, verifique suas credenciais e faça login novamente ou entre em contato com o administrador para obter mais informações.",
            btnLabel: "Fechar",
          })
        );
      }
    } else {
      return Promise.reject(error.response);
    }
  }
};

const withInterceptor = (axiosInstance) => {
  axiosInstance.interceptors.request.use(requestConfigInterceptor, (error) =>
    Promise.reject(error)
  );
  axiosInstance.interceptors.response.use(
    (response) => response,
    useResponseErrorInterceptor
  );

  return axiosInstance;
};

export const apiInstance = axios.create({
  baseURL: `${REACT_APP_ASAP_FRACIONADOS_BASE_URL}/v1/torredecontrole/backoffice`,
  timeout: 300000,
});

export const API_ASAP_FRACIONADOS = withInterceptor(apiInstance);
